import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService, EmailEventsFilters, ResponseObject } from './auth.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EmailParameterResponse } from './email-events.service';
import { Events, Parameters } from '../models/emailevents.model';

@Injectable({
  providedIn: 'root'
})
export class EmailEventTypeService extends ServiceBase{
  private api: string = '/EmailEventTypes';

  constructor(private http: HttpClient,
      authService: AuthService) {
      super(authService);
  }

public fetchEmailevents(filter: EmailEventsFilters): Observable<Events[]> {
  const httpOptions = this.RequestHeaders();
  const method = '/fetch-email-events';
  const url = `${environment.BASE_API_PATH}${this.api}${method}`;

  // Pass payload exactly like { emailEventsFiltersEnum: 0 }
  const requestBody = {
    emailEventsFiltersEnum: filter
  };

  return this.http.post<Events[]>(url, requestBody, httpOptions);
}



  public fetchEmailParameters(eventId?: string | null): Observable<Parameters[]> {
    var httpOptions = this.RequestHeaders();
    let method: string;
    if (eventId) {
      method = `/fetch-email-parameters/${eventId}`;
    } else {
      method = `/fetch-email-parameters`;
    }
    var url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<Parameters[]>(url, httpOptions);
  }


  public saveEmailEvents(saveEmailEmailEvets: Events): Observable<ResponseObject> {
      var httpOptions = this.RequestHeaders();
      
      const method: string = '/save-update-email-event';
      const url: string = environment.BASE_API_PATH + this.api + method;
      return this.http.post<ResponseObject>(url, saveEmailEmailEvets, httpOptions);
  }

  public saveEmailParameterData(emailParameterData: EmailParameterResponse): Observable<ResponseObject> {
      var httpOptions = this.RequestHeaders();    
      const method: string = '/update-email-parameter-fields';
      const url: string = environment.BASE_API_PATH + this.api + method;
      return this.http.post<ResponseObject>(url, emailParameterData, httpOptions);
  }

  public deleteEmailEvent(eventId: string): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const method: string = `/delete-email-event/${eventId}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }
  
}
